import { useEffect, useState } from 'react';

import { SEARCH_MAIN_INDEX_ID } from 'bundles/search-common/constants';
import { useSearch } from 'bundles/search-common/providers/SearchContext';
import { type SearchResult } from 'bundles/search-common/providers/searchTypes';

export function useStableObject<T>(newObj?: T) {
  const [stableObject, setStableObject] = useState<T | undefined>();

  useEffect(() => {
    if (newObj && Object.keys(newObj).length) {
      setStableObject(newObj);
    }
  }, [newObj]);

  return stableObject;
}

/**
 * Sometimes, and for TBD reasons, getSearchResults returns undefined while loading.
 * This is intended to be a temporary shim used to deliver one experimental feature.
 * This should ultimately be made unnecessary by a refactor of the search provider.
 */
const useStableSearchResults = (index?: string) => {
  const { getSearchResults } = useSearch();
  return useStableObject<SearchResult>(getSearchResults(index ?? SEARCH_MAIN_INDEX_ID));
};

export default useStableSearchResults;
